import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appDragScroll]',
  standalone: true,
})
export class DragScrollDirective {
  private isDown = false;
  private isDragging = false;
  private startX = 0;
  private scrollLeft = 0;
  private readonly DRAG_THRESHOLD = 5; // px ที่ถือว่าเป็น drag

  constructor(private el: ElementRef<HTMLElement>) {
    this.el.nativeElement.style.cursor = 'grab';
  }

  @HostListener('mousedown', ['$event'])
  onMouseDown(e: MouseEvent) {
    if (e.button !== 0) return; // เฉพาะ left click
    this.isDown = true;
    this.isDragging = false;
    this.startX = e.pageX - this.el.nativeElement.offsetLeft;
    this.scrollLeft = this.el.nativeElement.scrollLeft;
  }

  @HostListener('mouseleave')
  onMouseLeave() {
    this.isDown = false;
    this.isDragging = false;
    this.el.nativeElement.style.cursor = 'grab';
  }

  @HostListener('mouseup')
  onMouseUp() {
    this.isDown = false;
    this.isDragging = false;
    this.el.nativeElement.style.cursor = 'grab';
  }

  @HostListener('mousemove', ['$event'])
  onMouseMove(e: MouseEvent) {
    if (!this.isDown) return;
    const x = e.pageX - this.el.nativeElement.offsetLeft;
    const diff = x - this.startX;

    if (!this.isDragging && Math.abs(diff) < this.DRAG_THRESHOLD) return;

    // เริ่ม drag จริงๆ
    if (!this.isDragging) {
      this.isDragging = true;
      this.el.nativeElement.style.cursor = 'grabbing';
    }

    e.preventDefault();
    this.el.nativeElement.scrollLeft = this.scrollLeft - diff * 1.5;
  }

  @HostListener('click', ['$event'])
  onClick(e: MouseEvent) {
    // ถ้ากำลัง drag อยู่ ให้ block click ไม่ให้ลามไปถึงปุ่มลูก
    if (this.isDragging) {
      e.stopPropagation();
      e.preventDefault();
    }
  }
}
